import { render } from "./ProductWithBadgeSkeleton.vue?vue&type=template&id=59840a0e"
import script from "./ProductWithBadgeSkeleton.vue?vue&type=script&lang=js"
export * from "./ProductWithBadgeSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__